function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#12549F",
  rx: 2.462
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.325 8c.438 0 .738.137 1.05.238v1.487c-.037.013-.063-.05-.1-.075-.275-.2-.688 0-.725.325-.013.15.037.325.063.488.1.462.225.9.35 1.312.175.55.425 1.137.375 1.838-.05.662-.35 1.137-.825 1.4a1.58 1.58 0 0 1-.9.187 2.58 2.58 0 0 1-.888-.225v-1.637c.025-.013.075.025.113.05.037.024.075.05.125.062.287.1.637-.037.662-.337.025-.263-.063-.563-.137-.8-.226-.713-.538-1.325-.675-2.15-.1-.613-.013-1.126.287-1.513.138-.175.313-.325.513-.425.2-.112.425-.2.712-.225zm-4.437.037v1.675H6.35V15.2c-.6 0-1.225.013-1.813-.012V9.7H4V8.025c.963 0 1.938-.013 2.888.012zm2.212 0V15.2H7.287V8.063c.013-.013 0-.026.013-.026h1.8zM19.65 9c.2.313.325.65.338 1.075.024.513 0 .938 0 1.413V12.9c0 .463-.075.862-.25 1.162-.325.6-.9 1.05-1.713 1.113a2.02 2.02 0 0 1-1.137-.263 2.01 2.01 0 0 1-.726-.687 2.067 2.067 0 0 1-.337-1.075c-.025-.938 0-1.9 0-2.825 0-.512.075-.825.25-1.162.238-.45.6-.813 1.125-1 .175-.063.375-.1.588-.126.9-.062 1.512.425 1.862.963zm-4.375-.963v1.538c-.463-.05-.763.063-.863.388-.062.2-.025.537-.025.8v1.65c0 .274-.037.587.025.8.088.35.413.475.875.425v1.537c-.987.05-1.625-.3-2.025-.863a2.13 2.13 0 0 1-.4-1.037c-.024-.213-.012-.463-.012-.713V10.4c0-.25 0-.475.037-.688a2.16 2.16 0 0 1 .85-1.312c.376-.25.863-.413 1.538-.363zm2.55 1.563c-.212.013-.337.162-.412.325-.088.212-.05.563-.05.8v1.713c0 .3-.038.624.024.824.1.3.425.488.726.35a.607.607 0 0 0 .3-.35c.062-.2.024-.562.024-.8V10.8c0-.288.038-.613-.024-.813-.076-.237-.288-.437-.588-.387z"
}));

var SvgIcTisco = function SvgIcTisco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    style: {
      background: "#fff"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTisco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_tisco.55f6cb7a.svg";
export { ForwardRef as ReactComponent };